import React from "react";
import styled from "styled-components";
import { Box, Button, Text } from "@origin-digital/ods-core";
import { IHoverBoxProps, INavItemProps } from "../types";
import {
  ChangesIcon,
  DraftsIcon,
  LogoutIcon,
  ReportsIcon,
  RequestIcon,
  TasksIcon,
} from "../Icons";
import { useNavItem } from "./useNavItem";

// TODO use theme from styled instead of color code
// TODO move to higher level
const HoverBox = styled(Box)<IHoverBoxProps>`
  background-color: ${({ selected }) => (selected ? "#f1f1f1" : "transparent")};
  &:hover {
    background-color: #f8f8f8;
    cursor: pointer;
  }
`;
const ListButton = styled(Button)`
  width: 100%;
  height: 100%;
  padding: 16px 24px !important;
  border-radius: 0px !important;
  display: flex;
  justify-content: flex-start;
`;

const BadgeText = styled(Text)({
  fontSize: "11px",
});

const NavItemBelowLg = (props: INavItemProps) => {
  const { title, count, selected, handleClick } = useNavItem(props);

  const getIconByRoute = (navRoutes: string[]) => {
    switch (navRoutes[0]) {
      case "/":
      case "/projects":
        return <RequestIcon />;
      case "/changes":
        return <ChangesIcon />;
      case "/drafts":
        return <DraftsIcon />;
      case "/tasks":
        return <TasksIcon />;
      case "/reports":
        return <ReportsIcon />;
      case "/logout":
        return <LogoutIcon />;
      default:
        return <></>;
    }
  };

  const renderCountBadge = (badgeCount?: number) => {
    if (!badgeCount || badgeCount === 0) return null;
    return (
      <Box
        display="inline-flex"
        justifyContent="center"
        alignItems="center"
        backgroundColor="critical"
        paddingX="xsmall"
        style={{
          height: "24px",
          minWidth: "24px",
          borderRadius: "48px",
        }}
      >
        <BadgeText
          variant="caption"
          weight="medium"
          tone="white"
          align="center"
        >
          {badgeCount}
        </BadgeText>
      </Box>
    );
  };

  return (
    <HoverBox selected={selected}>
      <ListButton
        component="a"
        variant="text"
        color="secondaryB"
        iconPosition="leading"
        icon={getIconByRoute(props.routes)}
        //size="small"
        onClick={() => {
          handleClick();
        }}
      >
        <Box display="flex" gap="xsmall" flexWrap="wrap">
          <Text weight="medium" tone="neutralDark">
            {title}
          </Text>
          {renderCountBadge(count)}
        </Box>
      </ListButton>
    </HoverBox>
  );
};

export default NavItemBelowLg;
